<template>
  <v-dialog
    v-model="enable"
    persistent
    max-width="500px"
  >
    <v-card>
      <v-container>
        <v-card-title class="headline px-0">
          Edit PosServer
        </v-card-title>
        <v-card-text class="px-2">
          <v-form
            id="form_register"
            ref="form"
            v-model="isValid"
            lazy-validation
          >
            <v-flex>
              <v-checkbox
                v-model="req.cloudServer"
                label="Cloud Server"
              />
            </v-flex>
            <v-flex>
              <v-text-field
                v-model="req.name"
                append-icon="mdi-account-box"
                :rules="nameRules"
                label="PosServer Name*"
                autofocus
                required
                :error-messages="getError('Name')"
                @mouseup="dirtyError('Name')"
              />
            </v-flex>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <div>
            <small style="font-weight: 400; margin-right: 4px">
              *indicates required field</small>
          </div>
          <v-spacer />
          <v-btn
            id="register_close"
            color="error"
            class="white--text"
            @click.native="close()"
          >
            Close
          </v-btn>
          <v-btn
            id="register_save"
            color="success"
            class="white--text"
            :disabled="!isValid"
            :loading="loader"
            @click.native="editPosServer()"
          >
            {{ actionStatus === 'edit' ? 'Save' :'Approve' }}
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EditPosServer",
  data() {
    return {
      posServerId: null,
      isValid: false,
      loader: false,
      enable: false,
      req: {
        name: ""
      },
      errors: {},
      nameRules: [
        (v) => !!v || "PosServer name is required",
        (v) =>
          (v && v.length <= 50) ||
          "PosServer name must be less than 50 characters"
      ],
      taxExcludeHint:
        "Taxes will be recorded, but it will be excluded from the reports.",
      actionStatus:""
    };
  },
  methods: {
    open(id,status) {
      this.posServerId = id;
      this.actionStatus=status;
      this.getPosServer(id);
    },
    close() {
      this.enable = false;
      this.clear();
    },
    getPosServer(id) {
      this.loader = true;
      let url = `${this.ADMIN_API_URL}/posServers/${id}`;
      this.$http.get(url).then(
        function (res) {
          this.loader = false;
          this.enable = true;
          this.req = {
            name: res.body.name,
            cloudServer: res.body.cloudServer
          };
        },
        function (failure) {
          this.handleFailure(failure);
        }
      );
    },

    editPosServer: function () {
      if (!this.$refs.form.validate()) {
        return;
      }
      if(this.actionStatus === "activate"){
        this.$root.$confirm
        .open("Confirm", "Are you sure you want to activate?", {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.loader = true;
          this.req.posServerId = this.posServerId;
          this.req.activeStatus = true;
          this.req.approvedStatus = true;
          
          this.$http
        .put(`${this.ADMIN_API_URL}/posServers/${this.posServerId}`, this.req)
        .then(
          function (data) {
            this.loader = false;
            this.close();
            this.$emit("reload");
            this.$store.commit("showSnackbar", {
              timeout: 3000,
              message: data.body.message
            });
          },
          function (failure) {
            this.loader = false;
            this.handleFailure(failure);
          }
        );

        });

      }else if(this.actionStatus === "edit"){
        this.loader = true;
          this.req.posServerId = this.posServerId; 
          this.$http
        .put(`${this.ADMIN_API_URL}/posServers/${this.posServerId}`, this.req)
        .then(
          function (data) {
            this.loader = false;
            this.close();
            this.$emit("reload");
            this.$store.commit("showSnackbar", {
              timeout: 3000,
              message: data.body.message
            });
          },
          function (failure) {
            this.loader = false;
            this.handleFailure(failure);
          }
        );

      }
   
     
     
    },
    getError(key) {
      return this.errors && this.errors[key] ? [this.errors[key]] : [];
    },
    dirtyError(key) {
      this.errors[key] = "";
    },
    handleFailure: function (failure) {
      let msg = failure.body.message || "UnKnown error";
      let errors = failure.body.errors;
      if (errors && errors.Name) {
        msg = errors.Name;
      }
      this.$store.commit("showSnackbar", {
        message: msg,
        color: "error"
      });
    },
    clear() {
      this.errors = {};
      this.$refs.form.reset();
    }
  }
};
</script>